import request from '@/utils/request';

export function getSignalPriorityAsKeyValuePairList() {
  return request({
    url: '/api/priority/GetPriorityAsKeyValuePairList',
    method: 'get',
  });
}

